import { DropdownToggle as _DropdownToggle, DropdownToggleProps as _DropdownToggleProps } from "reactstrap";

    export const DropdownToggle = _DropdownToggle;
    export type DropdownToggleProps = _DropdownToggleProps;
    